/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#content[_ngcontent-%COMP%]{font-family:Poppins!important}h5[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#3c4858}.line-height-160[_ngcontent-%COMP%], .line-height-160[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{line-height:160%!important}.line-height-180[_ngcontent-%COMP%], .line-height-180[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{line-height:180%!important}.line-height-200[_ngcontent-%COMP%], .line-height-200[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{line-height:200%!important}"];
export { styles as styles };
